var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-form",
        {
          nativeOn: {
            keyup: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.saveAll.apply(null, arguments)
            }
          }
        },
        [
          _c("v-slide-y-transition", { attrs: { mode: "out-in" } }, [
            _c(
              "div",
              [
                _c("br"),
                _vm._v(" "),
                _c(
                  "v-expansion-panel",
                  { attrs: { slot: "content", value: 0 }, slot: "content" },
                  [
                    _c(
                      "v-expansion-panel-content",
                      {
                        staticClass: "panel-content",
                        staticStyle: { background: "transparent" }
                      },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "header" }, slot: "header" },
                          [
                            _c("h4", [
                              _vm._v(_vm._s(_vm.$t("settings.language")))
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-list",
                          [
                            _c("v-list", { attrs: { dense: "" } }, [
                              _c(
                                "div",
                                { staticStyle: { padding: "0 0 0 10px" } },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "" } },
                                    [
                                      _c("v-spacer"),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { sm6: "" } },
                                        [
                                          _c("v-select", {
                                            attrs: {
                                              label: _vm.$t(
                                                "settings.appLocale"
                                              ),
                                              items: _vm.appLocales
                                            },
                                            model: {
                                              value:
                                                _vm.mapSettingsTransient.locale,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.mapSettingsTransient,
                                                  "locale",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "mapSettingsTransient.locale"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { sm6: "" } },
                                        [
                                          _c("v-select", {
                                            attrs: {
                                              label: _vm.$t("settings.unit"),
                                              items: _vm.availableUnits
                                            },
                                            model: {
                                              value:
                                                _vm.mapSettingsTransient.unit,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.mapSettingsTransient,
                                                  "unit",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "mapSettingsTransient.unit"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "" } },
                                    [
                                      _c("v-spacer"),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { sm6: "" } },
                                        [
                                          _c("v-select", {
                                            attrs: {
                                              label: _vm.$t(
                                                "settings.routeInstructions"
                                              ),
                                              items: _vm.routingLocales
                                            },
                                            model: {
                                              value:
                                                _vm.mapSettingsTransient
                                                  .routingInstructionsLocale,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.mapSettingsTransient,
                                                  "routingInstructionsLocale",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "mapSettingsTransient.routingInstructionsLocale"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { sm6: "" } },
                                        [
                                          _c("v-select", {
                                            attrs: {
                                              label: _vm.$t(
                                                "settings.areaUnit"
                                              ),
                                              items: _vm.availableAreaUnits
                                            },
                                            model: {
                                              value:
                                                _vm.mapSettingsTransient
                                                  .areaUnit,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.mapSettingsTransient,
                                                  "areaUnit",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "mapSettingsTransient.areaUnit"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c(
                  "v-expansion-panel",
                  { attrs: { slot: "content", value: null }, slot: "content" },
                  [
                    _c(
                      "v-expansion-panel-content",
                      {
                        staticClass: "panel-content",
                        staticStyle: { background: "transparent" }
                      },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "header" }, slot: "header" },
                          [
                            _c("h4", [
                              _vm._v(_vm._s(_vm.$t("settings.mapSettings")))
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-list",
                          { attrs: { dense: "" } },
                          [
                            _c(
                              "v-container",
                              {
                                staticStyle: {
                                  "padding-top": "0",
                                  "padding-bottom": "0"
                                },
                                attrs: { fluid: "" }
                              },
                              [
                                _c("h4", [
                                  _vm._v(
                                    _vm._s(_vm.$t("settings.mapViewOptions"))
                                  )
                                ]),
                                _vm._v(" "),
                                _c("v-checkbox", {
                                  staticClass: "pt-0 top-0",
                                  attrs: {
                                    label: _vm.$t("settings.alwaysFitBounds")
                                  },
                                  model: {
                                    value:
                                      _vm.mapSettingsTransient.alwaysFitBounds,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.mapSettingsTransient,
                                        "alwaysFitBounds",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "mapSettingsTransient.alwaysFitBounds"
                                  }
                                }),
                                _vm._v(" "),
                                _c("v-checkbox", {
                                  staticClass: "pt-0 top-0",
                                  attrs: {
                                    label: _vm.$t(
                                      "settings.prioritizeSearchingForNearbyPlaces"
                                    )
                                  },
                                  model: {
                                    value:
                                      _vm.mapSettingsTransient
                                        .prioritizeSearchingForNearbyPlaces,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.mapSettingsTransient,
                                        "prioritizeSearchingForNearbyPlaces",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "mapSettingsTransient.prioritizeSearchingForNearbyPlaces"
                                  }
                                }),
                                _vm._v(" "),
                                _c("v-select", {
                                  attrs: {
                                    label: _vm.$t(
                                      "settings.defaultTilesProvider"
                                    ),
                                    items: _vm.availableTileServices
                                  },
                                  model: {
                                    value:
                                      _vm.mapSettingsTransient
                                        .defaultTilesProvider,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.mapSettingsTransient,
                                        "defaultTilesProvider",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "mapSettingsTransient.defaultTilesProvider"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c(
                  "v-layout",
                  { attrs: { row: "", wrap: _vm.$lowResolution } },
                  [
                    _c(
                      "v-flex",
                      [
                        _c("v-checkbox", {
                          attrs: {
                            label: _vm.$t("settings.saveToLocalStorage")
                          },
                          model: {
                            value: _vm.mapSettingsTransient.saveToLocalStorage,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.mapSettingsTransient,
                                "saveToLocalStorage",
                                $$v
                              )
                            },
                            expression:
                              "mapSettingsTransient.saveToLocalStorage"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      [
                        _c("v-checkbox", {
                          attrs: {
                            label: _vm.$t("settings.resetShownOnceTooltips")
                          },
                          model: {
                            value: _vm.resetShownOnceTooltips,
                            callback: function($$v) {
                              _vm.resetShownOnceTooltips = $$v
                            },
                            expression: "resetShownOnceTooltips"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  { attrs: { row: "", wrap: _vm.$lowResolution } },
                  [
                    _c("v-spacer", { staticClass: "hidden-md-and-down" }),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      {
                        class: {
                          "ml-2": _vm.$vuetify.breakpoint.smAndDown,
                          "mb-2": _vm.$lowResolution
                        },
                        attrs: {
                          "text-xs-right": "",
                          xs12: "",
                          sm5: "",
                          md7: ""
                        }
                      },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              block: _vm.$lowResolution,
                              color: "primary",
                              title: _vm.$t("settings.restoreDefaults")
                            },
                            on: { click: _vm.restoreDefaultMapSettings }
                          },
                          [_vm._v(_vm._s(_vm.$t("settings.restoreDefaults")))]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      {
                        class: { "ml-2": _vm.$vuetify.breakpoint.smAndDown },
                        attrs: {
                          "text-xs-right": "",
                          xs12: "",
                          sm3: "",
                          md3: ""
                        }
                      },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              block: _vm.$lowResolution,
                              color: "primary",
                              title: _vm.$t("global.save")
                            },
                            on: { click: _vm.saveAll }
                          },
                          [
                            _vm._v(
                              "\n              " + _vm._s(_vm.$t("global.save"))
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("br")
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-12a7724c", { render: render, staticRenderFns: staticRenderFns })
  }
}